import { action, observable } from 'mobx';

import customFetch from '../../../utils/customFetch';

class ClaimantsStore {
  @observable loading = true;
  @observable loadingSearch = true;
  @observable loadingHistory = true;
  @observable loadingClaimantGroup = true;

  @observable data = null;
  @observable dataSearch = null;
  @observable dataHistory = null;
  @observable dataClaimantGroup = null;

  @observable filter = 'active';
  @observable sortDirection = 'ascending';
  @observable keyword = '';
  @observable keywordSearch = '';
  @observable sortColumn = 'First Name';
  @observable sortKey = 'FirstName';

  @observable curPage = 1;
  @observable pageSize = 20;
  @observable listSize = 30;
  @observable totalPage = 0;
  @observable totalItems = 0;
  @observable numberSearch = 30;
  @observable id = '';
  // @observable claimantGroupId = 'All';
  @observable IsSelectionList = true;

  @observable open = false;
  @observable modalParams = {};

  @action setFieldsValue = obj => {
    Object.keys(obj).forEach(key => {
      this[key] = obj[key];
    });
  };

  @action fetchSearch = () => {
    this.loadingSearch = true;
    customFetch('/PatientInfo/GetPatientList', {
      method: 'POST',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify({
        IsSelectionList: true,
        Showing: this.filter,
        Keyword: this.keywordSearch,
        CurPage: 1,
        NumItemPerPage: this.numberSearch,
        SortBy: this.sortKey,
        SortDirection: this.sortDirection.replace('ending', '').toUpperCase(),
      }),
    }).then(
      action(data => {
        this.dataSearch = data;
        this.loadingSearch = false;
      }),
    );
  };

  @action fetchClaimants = (setTotalPage = false) => {
    this.loading = true;
    customFetch('/PatientInfo/GetPatientList', {
      method: 'POST',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify({
        Showing: this.filter,
        Keyword: this.keyword,
        CurPage: this.curPage,
        NumItemPerPage: this.pageSize,
        SortBy: this.sortKey,
        SortDirection: this.sortDirection.replace('ending', '').toUpperCase(),
      }),
    }).then(
      action(data => {
        this.fetchSearch();
        this.data = data;
        if (data.curPage <= 1) {
          this.totalPage = data.sumPage;
          this.totalItems = data.sumItem;
        }
        this.loading = false;
      }),
    );
  };

  @action fetchHistory = () => {
    this.loadingHistory = true;
    customFetch('/PatientInfo/GetPatientAppointmentHistory', {
      method: 'POST',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify({
        id: this.modalParams.id,
      }),
    }).then(
      action(data => {
        this.dataHistory = data;
        this.loadingHistory = false;
      }),
    );
  };

  @action fetchClaimantGroup = () => {
    this.loadingClaimantGroup = true;

    customFetch('/PatientInfo/GetPatientList', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        IsSelectionList: this.IsSelectionList,
        numItemPerPage: this.listSize,
      }),
    }).then(
      action(data => {
        this.dataClaimantGroup = data;
        this.loadingClaimantGroup = false;
      }),
    );
  };

  @action handleSort = ({ sortKey }, { column, direction }) => {
    this.sortColumn = column;
    this.sortDirection = direction;
    this.sortKey = sortKey;
    this.fetchClaimants();
  };

  @action refetch = (data = {}, setTotalPage) => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    this.fetchClaimants(setTotalPage);
  };

  @action refetchSearch = (data = {}) => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    this.fetchSearch();
  };

  @action refetchGroup = (data, setTotalPage) => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    this.fetchClaimants(setTotalPage);
  };

  @action handleSearchChange = ({ target }) => {
    this.keyword = target.value;
  };

  toggleModal = (isOpen, params = {}) => {
    return action(() => {
      this.open = isOpen;
      this.modalParams = params;
    });
  };

  @action resetStore = () => {
    this.keyword = '';
    this.filter = 'active';
    this.sortColumn = 'First Name';
    this.sortKey = 'FirstName';
    this.sortDirection = 'ascending';

    this.curPage = 1;
    this.totalPage = 0;
    this.refetch({}, true);
  };
  @action resetSearch = () => {
    this.keywordSearch = '';
    this.numberSearch = 30;

    this.refetchSearch({});
  };
}

export default new ClaimantsStore();
